// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2pupi","actionsCol":"EnrolledClinics_actionsCol__2Hug6"};